<template>
  <div class="massLoss-list">
    <div class="nav">
      <el-form :model="searchForm" :inline="true" class="demo-form-inline flex1" ref="searchForm">
        <!-- update-begin--author:ZhouShiPeng---date:2023/5/4-->
        <el-form-item label="板块：" label-width="60px">
          <el-select v-model="searchForm.plate" filterable size="mini" style="width: 150px" placeholder="请选择板块">
            <el-option v-for="item in plateOption" :key="item.label" :label="item.label" :value="item.value" />
          </el-select>
        </el-form-item>
        <el-form-item label="类别：" label-width="60px">
          <el-select v-model="searchForm.type" filterable size="mini" style="width: 150px" placeholder="请选择类别">
            <el-option v-for="item in typeOption" :key="item.label" :label="item.label" :value="item.value" />
          </el-select>
        </el-form-item>
        <el-form-item label="是否推送：" label-width="90px">
          <el-select v-model="searchForm.isSend" filterable size="mini" style="width: 150px" placeholder="请选择是否推送">
            <el-option v-for="item in isSendOption" :key="item.label" :label="item.label" :value="item.value" />
          </el-select>
        </el-form-item>
        <el-form-item label="台账编号：" label-width="110px">
          <!--          <el-date-picker v-model='searchForm.actualSbm' size='mini' value-format='yyyyMM'-->
          <!--                          type='month' placeholder='请选择台账月' />-->
          <el-input v-model="searchForm.ledgerNumber" size="mini" placeholder="请输入台账编号" />
        </el-form-item>
        <el-form-item label="标题：" label-width="60px">
          <el-input v-model="searchForm.title" size="mini" placeholder="请输入标题" style="width: 170px" />
        </el-form-item>
        <el-form-item label="提交人：" label-width="80px">
          <el-input v-model="searchForm.createBy" size="mini" placeholder="请输入提交人" style="width: 170px" />
        </el-form-item>
        <div class="navContainer" style="width: 450px; display: flex;">
          <p>提交日期：</p>
          <el-date-picker v-model="dealersIpt[0]" size="mini" style="width: 150px" value-format="yyyy-MM-dd" @change="dateChange2" type="date" placeholder="开始日期" />
          <span style="display: inline-block; width: 15px; text-align: center; font-size: 18px">-</span>
          <el-date-picker v-model="dealersIpt[1]" size="mini" style="width: 150px" value-format="yyyy-MM-dd" @change="dateChange2" type="date" placeholder="结束日期" />
        </div>
        <el-form-item>
          <el-button size="small" class="searchBtn" @click="searchBtn">查询</el-button>
          <el-button size="small" class="resetBtn" @click="resetBtn">重置</el-button>
        </el-form-item>
      </el-form>
    </div>
    <el-row>
      <el-col :span="2" style="text-align: end; font-size: 14px !important; margin-left: -25px" class="exportButton">
        <span @click="exportDatas">导出汇总数据</span>
      </el-col>
      <el-col :span="22" style="text-align: end; font-size: 14px !important" class="exportButton">
        <span @click="exportData">导出数据</span>
      </el-col>
    </el-row>
    <div class="content">
      <div class="tableContainer">
        <el-table ref="multipleTable" v-loading="tableLoading" :data="tableData" style="width: 100%" border @selection-change="selectionDataChange" :header-cell-style="headerCellStyle" :row-style="rowStyle">
          <el-table-column type="selection" align="center" width="50px" />
          <el-table-column type="index" label="序号" align="center" />
          <el-table-column label="板块" align="center">
            <span slot-scope="scope">{{ scope.row.plate | getPlateType }}</span>
          </el-table-column>
          <el-table-column label="类别" align="center">
            <span slot-scope="scope">{{ scope.row.type | getType }}</span>
          </el-table-column>
          <el-table-column prop="ledgerNumber" label="台账编号" align="center" />
          <el-table-column prop="title" label="标题" align="center" />
          <el-table-column prop="count" label="数量" align="center" />
          <el-table-column prop="srPrice" label="应收金额" align="center" />
          <el-table-column prop="zcPrice" label="应付金额" align="center" />
          <el-table-column prop="createBy" label="提交人" align="center" />
          <!--          <el-table-column prop='ledgerNumber' label='数量' align='center' />-->
          <!--          <el-table-column prop='ledgerNumber' label='金额' align='center' />-->
          <el-table-column prop="createTime" label="提交时间" align="center" />
          <!--          <el-table-column prop='ledgerNumber' label='提交人' align='center' />-->
          <el-table-column prop="isSend" label="是否推送" align="center">
            <template slot-scope="scope">
              <span>{{ scope.row.isSend == 0 ? '未推送' : scope.row.isSend == 1 ? '部分推送' : scope.row.isSend == 2 ? '全部成功推送' : '' }}</span>
            </template>
          </el-table-column>
          <el-table-column label="操作" align="center" width="350px">
            <template slot-scope="scope">
              <el-button size="mini" class="searchBtn btns" type="primary" @click="btnClick('cancel', scope.row)">作废</el-button>
              <el-button size="mini" class="searchBtn btns" type="primary" @click="btnClick('info', scope.row)">明细 </el-button>
              <el-button size="mini" class="searchBtn btns" type="primary" @click="btnClick('edit', scope.row)">编辑 </el-button>
              <el-button size="mini" class="searchBtn btns" type="primary" @click="btnClick('delete', scope.row)">删除 </el-button>
              <el-button size="mini" class="searchBtn btns" type="primary" @click="btnClick('push', scope.row)" :loading="loadingPushFunc(scope.row)" v-if="scope.row.isSend == 0 || scope.row.isSend == 1">推送 </el-button>
              <el-button size="mini" type="primary" @click="btnClick('pushError', scope.row)">推送报错 </el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="paginationContainer">
        <el-pagination background :page-sizes="[10, 20, 30, 40]" layout="total, sizes, prev, pager, next, jumper" :total="total" @size-change="contractSizeChange" @current-change="contractCurrentChange" :current-page.sync="searchForm.page" :page-size="searchForm.rows" />
      </div>
    </div>
    <info ref="infoRef" />
    <!-- update-begin--author:ZhouShiPeng---date:2023/5/4--for-- 编辑台账编码-->
    <el-dialog :visible.sync="dialogVisible" :title="dialogTitle" :close-on-click-modal="false" @close="dialogClose" width="800px">
      <!--      编辑台账编码-->
      <div class="dialogContent">
        <el-form :model="from" label-width="110px" :inline="true" :rules="rules" class="demo-form-inline flex1" ref="form">
          <el-form-item label="台账标题：" prop="title">
            <el-input v-model="from.title" size="mini" placeholder="请输入台账标题" style="width: 350px" />
          </el-form-item>
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button size="medium" class="resetBtn" @click="dialogClose">取 消</el-button>
        <el-button size="medium" class="searchBtn" :loading="buttonLoading" @click="dialogSubmit">确 定</el-button>
      </div>
    </el-dialog>
    <!-- 作废选择弹窗 -->
    <el-dialog :visible.sync="dialogVisibleCancel" title="作废数据" :close-on-click-modal="false" @close="dialogCloseCancel" :destroy-on-close="true" width="50%">
      <Cancel ref="cancelRef" :summaryId="activeSummaryId" @closeCancelDialog="closeCancelDialog" />
    </el-dialog>
    <!--  推送报错  -->
    <push-error ref="pushErrorRef"/>
  </div>
</template>

<script>
  import { deleteTheLedgerCode, editTheLedgerCode, pageSbmCountList, pushOne, deleteAccount, detele2 } from '@/service/account';
  import Info from './components/info.vue';
  import Cancel from './components/cancel.vue';
  import ImportStatement from '@/views/settle/entrust/components/import-statement.vue';
  import { getSessionStore } from '@/config/mUtils';
  import { baseUrl } from '@/config/env';
  import { electronicFenceDelete } from '@/service/DevOps';
  import PushError
    from '@/views/settle/accountManagement/ledgerOrReconciliationSummary/components/pushError.vue';

  export default {
    name: 'ledgerOrReconciliationSummary',
    components: { PushError, ImportStatement, Info, Cancel },
    data() {
      return {
        activeSummaryId: '',
        activeId: '',
        loadingPush: false,
        searchForm: {
          plate: '',
          type: '',
          ledgerNumber: '',
          title: '',
          submitType: '',
          createBy: '',
          page: 1,
          rows: 10,
          isSend: '',
          createStartDate: '',
          createEndDate: '',
        },
        dealersIpt: ['', ''], // 交车日期
        plateOption: [
          {
            label: '全部',
            value: '',
          },
          {
            label: '运输',
            value: '1',
          },
          {
            label: '库房及其他',
            value: '2',
          },
          {
            label: '其他费用',
            value: '3',
          },
        ],
        typeOption: [
          {
            label: '全部',
            value: '',
          },
          {
            label: '提交台账',
            value: '1',
          },
          {
            label: '更正台账',
            value: '2',
          },
          {
            label: '调整台账',
            value: '3',
          },
        ],
        isSendOption: [
          {
            label: '全部',
            value: '',
          },
          {
            label: '未推送',
            value: '0',
          },
          {
            label: '部分推送',
            value: '1',
          },
          {
            label: '全部推送',
            value: '2',
          },
        ],
        defaultSearchForm: {},
        tableLoading: false,
        tableData: [],
        checkTableData: [],
        headerCellStyle: {
          color: '#3B3B3B',
          'font-size': '13px',
          height: '48px',
          background: '#E8E8E8',
        },
        total: 0,
        dialogVisible: false,
        dialogVisibleCancel: false,
        dialogTitle: '',
        buttonLoading: false,
        from: {
          title: '',
          id: '',
        },
        rules: {
          title: [{ required: true, message: '请输入台账标题', trigger: 'blur' }],
        },
      };
    },
    filters: {
      getPlateType(val) {
        switch (val) {
          case 1:
            return '运输';
          case 2:
            return '库房及其他';
          case 3:
            return '其他费用';
        }
      },
      getType(val) {
        switch (val) {
          case 1:
            return '提交台账';
          case 2:
            return '更正台账';
          case 3:
            return '调整台账';
        }
      },
    },
    watch: {
      $route(to, from) {
        // this.searchForm.submitType = this.$route.meta.submitType;
        this.defaultSearchForm = JSON.parse(JSON.stringify(this.searchForm));
        this.searchBtn();
      },
    },
    mounted() {
      // this.searchForm.submitType = this.$route.meta.submitType;
      this.defaultSearchForm = JSON.parse(JSON.stringify(this.searchForm));
      // this.searchBtn();
    },
    methods: {
      loadingPushFunc(row) {
        return row.id === this.activeId;
      },
      async btnClick(str, row) {
        switch (str) {
          case 'info':
            this.$refs.infoRef.dialogOpen(row.type, row.id, row.plate, row.ledgerNumber, row.title);
            break;
          case 'edit':
            this.dialogVisible = true;
            this.dialogTitle = '编辑台账标题';
            this.from = {
              title: row.title,
              id: row.id,
            };
            break;
          case 'delete':
            this.fenceDelete(row, str);
            break;
          case 'pushError':
            this.$refs.pushErrorRef.dialogOpen(row.id);
            break;
          case 'push':
            // this.activeId = row.id;
            this.tableLoading = true;
            const res = await pushOne({ id: row.id, plate: row.plate });
            console.log(res);
            setTimeout(() => {
              if (res.status == 0) {
                this.$message({
                  showClose: true,
                  message: res.message,
                  type: 'success',
                });
              } else {
                this.$message({
                  showClose: true,
                  message: res.message,
                  type: 'error',
                });
              }
              // this.activeId = '';
              this.tableLoading = false;
            }, 100);

            break;
          case 'cancel':
            // console.log('作废');
            this.activeSummaryId = row.id;
            this.dialogVisibleCancel = true;
            this.$nextTick(() => {
              this.$refs.cancelRef.showData();
            })
        }
      },
      // 查询
      searchBtn() {
        this.searchForm.page = 1;
        this.searchForm.createStartDate = this.dealersIpt ? this.dealersIpt[0] || '' : '';
        this.searchForm.createEndDate = this.dealersIpt ? this.dealersIpt[1] || '' : '';
        this.getTableData();
      },
      // 重置
      resetBtn() {
        this.dealersIpt = ['', ''];
        this.searchForm = JSON.parse(JSON.stringify(this.defaultSearchForm));
        this.searchBtn();
      },
      dateChange2(val) {
        if (this.dealersIpt[1] && this.dealersIpt[0] && this.dealersIpt[1] <= this.dealersIpt[0]) {
          if (val == this.dealersIpt[1]) this.dealersIpt[1] = '';
          if (val == this.dealersIpt[0]) this.dealersIpt[0] = '';
          this.$forceUpdate();
          return this.$message.warning('结束日期必须大于开始日期！');
        }
      },
      // 获取表格数据
      async getTableData() {
        this.tableLoading = true;
        const {
          status,
          message,
          data: { records, total },
        } = await pageSbmCountList(this.searchForm);
        this.tableLoading = false;
        if (status !== 0) return this.$message.warning(message);
        this.tableData = records;
        this.total = total;
      },
      contractSizeChange(row) {
        this.searchForm.rows = row;
        this.searchForm.page = 1;
        this.getTableData();
      },
      contractCurrentChange(page) {
        this.searchForm.page = page;
        this.getTableData();
      },
      dialogClose() {
        this.dialogVisible = false;
        this.from = this.$options.data().from;
        this.$refs.form.clearValidate();
      },
      dialogCloseCancel() {
        this.$refs.cancelRef.closeSelected();
        // this.dialogCloseCancel = false;
      },
      closeCancelDialog() {
        this.dialogVisibleCancel = false;
      },
      dialogSubmit() {
        this.$refs.form.validate(async valid => {
          if (valid) {
            this.buttonLoading = true;
            // 调用接口
            const { status, message } = await editTheLedgerCode(this.from);
            if (status !== 0) return this.$message.warning(message);
            this.$message.success(message);
            this.buttonLoading = false;
            this.dialogClose();
            await this.getTableData();
          } else {
            return false;
          }
        });
      },
      //删除
      fenceDelete(row) {
        this.$confirm('确认删除当前选中数据？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        }).then(async () => {
          this.tableLoading = true;
          let status = null;
          let message = null;
          if (row.plate == '1') {
            const res = await deleteTheLedgerCode({ id: row.id });
            status = res.status;
            message = res.message;
          } else if (row.plate == '2') {
            // this.$message.warning('请联系管理员！'); // detele2
            const res = await detele2({ id: row.id, ledgerNumber: row.ledgerNumber });
            status = res.status;
            message = res.message;
          } else if (row.plate == '3') {
            const res = await deleteAccount({ id: row.id });
            status = res.status;
            message = res.message;
          }
          this.tableLoading = false;
          if (status !== 0) return this.$message.warning(message);
          this.$message.success(message);
          this.searchBtn();
        });
      },
      //导出数据
      exportData() {
        if (this.searchForm.plate == '' && this.checkTableData == 0) return this.$message.warning('请选择板块或者勾选数据后导出');
        let token = getSessionStore('token');
        const plates = this.checkTableData.map(item => item.plate);
        const plateArr = plates.reduce((acc, cur) => {
          const array = acc.find(item => item.plate === cur.plate);
          if (!array) {
            acc.push(cur);
          }
          return acc;
        }, []);
        const plate = plateArr.join(',');
        const ids = this.checkTableData.map(item => item.id);
        const id = ids.join(',');
        if (this.searchForm.plate === '1' || plate === '1') {
          window.exportExcel(
            `${baseUrl}/platform/settlement/accountCollect/summary/countExportXls1?access_token=${token}`,
            {
              plateStr: this.searchForm.plate === '' ? plate : this.searchForm.plate,
              typeStr: this.searchForm.type,
              ledgerNumber: this.searchForm.ledgerNumber,
              title: this.searchForm.title,
              id,
            },
            '结算台账汇总',
          );
        } else {
          window.exportExcel(
            `${baseUrl}/platform/settlement/accountCollect/summary/exportXls?access_token=${token}`,
            {
              plateStr: this.searchForm.plate === '' ? plate : this.searchForm.plate,
              typeStr: this.searchForm.type,
              ledgerNumber: this.searchForm.ledgerNumber,
              title: this.searchForm.title,
              id,
            },
            '结算台账汇总',
          );
        }
        this.clearCheckTableData();
      },
      //导出汇总数据
      exportDatas() {
        let token = getSessionStore('token');
        window.exportExcel(
          `${baseUrl}/platform/settlement/accountCollect/summary/exportSummary?access_token=${token}`,
          {
            ...this.searchForm,
          },
          '结算台账汇总',
        );
      },
      clearCheckTableData() {
        this.$refs.multipleTable.clearSelection();
        this.checkTableData = [];
        this.getTableData();
      },
      rowStyle({ row }) {
        return this.checkTableData.includes(row) ? { background: 'rgb(197 226 255)' } : {};
      },
      selectionDataChange(val) {
        this.checkTableData = val;
        let checkTable = '';
        const array = val.filter((item, index) => {
          if (index === 0) checkTable = item.plate;
          return checkTable !== item.plate;
        });
        // 筛选  供应商相同数据
        this.checkTableData = val.filter(item => checkTable === item.plate);
        let tipOne = true;
        array.forEach(value => {
          // 只有使用表格原数据，才会生效   从表格原数据中赛选
          if (tipOne) {
            this.$message.warning('只能选择相同的板块');
            tipOne = false;
          }
          this.$refs.multipleTable.toggleRowSelection(
            this.tableData.find(item => value.id === item.id),
            false,
          );
        });
      },
    },
  };
</script>

<style lang="scss" scoped>
  .massLoss-list {
    /*width:100%;*/
    padding: 20px 15px 0 25px;
    height: 100%;
    /*overflow: auto;*/
    .nav {
      /*width:100%;*/
      display: flex;
      /*align-items: center;*/
      /*height:30px;*/
      overflow: hidden;

      .flex1 {
        flex: 1;
      }

      .el-input {
        width: 150px;
      }

      .el-select {
        width: 150px;
      }

      ::v-deep {
        label.el-form-item__label {
          font-weight: 500;
          color: #101010;
        }
      }
    }

    ::v-deep .detail {
      .el-form-item {
        margin-bottom: 2px;

        .el-form-item__label {
          /*color: #060606;*/
          font-weight: 700;
        }
      }

      .line {
        width: 12px;
        height: 32px;
        background-color: rgba(51, 84, 131, 100);
        margin-right: 10px;
      }

      .line + span {
        font-size: 16px;
        color: rgba(51, 84, 131, 100);
        font-weight: 600;
      }

      width: 100%;
      padding: 10px 0 20px 20px;

      .baseInfo {
        display: flex;
        flex-direction: column;

        &Title {
          display: flex;
          align-items: flex-end;

          p {
            font-weight: 700;
            font-size: 14px;
            color: rgba(249, 166, 6);
            margin-left: 10px;
          }
        }

        &Content {
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          padding: 20px 23px 0 23px;
          font-size: 14px;

          .center-f {
            display: flex;
          }
        }
      }

      .operation {
        display: flex;
        flex-direction: column;

        &Title {
          display: flex;
          align-items: flex-end;

          p {
            font-weight: 700;
            font-size: 14px;
            color: rgba(51, 136, 255, 1);
            margin-left: 10px;
          }
        }

        &Content {
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          padding: 20px 23px 0 23px;
          font-size: 14px;
        }

        &Table {
          width: 100%;
          margin-top: 10px;
          padding-right: 20px;
        }
      }
    }

    ::v-deep .add {
      .el-form-item__label {
        font-weight: 700;
      }

      width: 100%;

      .baseInfo {
        display: flex;
        flex-direction: column;

        &Content {
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          padding: 20px 23px 0 23px;
          font-size: 14px;

          .center-f {
            display: flex;
          }

          .yang {
            .el-form-item {
              .el-form-item__error {
                left: 40px;
              }

              margin-bottom: 5px;

              .el-form-item__label {
                // width: 150px !important;
                /*color: #060606;*/
              }
            }
          }

          .repair {
            .el-input {
              width: 80%;
            }

            .el-form-item {
              .el-form-item__error {
                /*left: 41px;*/
                padding-top: 0px;
              }

              margin-bottom: 7px;

              .el-form-item__label {
                /*width: 155px  !important;*/
                /*color: #060606;*/
              }
            }

            .el-upload-list__item {
              width: 100px;
              height: 100px;
            }

            .el-upload--picture-card {
              width: 100px;
              height: 100px;
              line-height: 100px;
            }

            /*display: none;*/
            .imgUp {
              display: flex;
              flex-direction: column;

              .imgLength {
                display: flex;
                align-items: center;
                width: 100%;

                span {
                  margin-left: auto;
                  color: rgb(183, 183, 183);
                  font-size: 16px;
                }
              }
            }
          }
        }
      }

      .btnContainer {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-bottom: 13px;
        margin-top: 20px;

        button {
          margin: 0 15px;
        }
      }
    }

    ::v-deep {
      .el-dialog__header {
        padding: 9px 20px 9px;
        background: #335483;
      }

      .el-dialog__title {
        line-height: 24px;
        font-size: 14px;
        color: #ffffff;
      }

      .el-dialog__headerbtn {
        top: 9px;
      }

      .el-dialog__headerbtn .el-dialog__close {
        color: #fff;
        font-size: 25px;
      }

      .el-dialog__body {
        padding: 0;
        overflow: auto;
        max-height: 75vh;
        color: #606266;
      }

      .el-form--inline .el-form-item {
        margin-bottom: 5px;
      }
    }
  }

  .tableContainer {
    margin: 10px 0 30px 0;
  }

  .exportButton {
    span {
      color: rgba(51, 136, 255, 1);
      font-size: 14px;

      &:hover {
        cursor: pointer;
      }
    }
  }

  .btns {
    margin-bottom: 10px;
  }
</style>
